import {InputType} from './types';
import {stringInputGenerator} from './inputs/StringInput';
import {rangeInputGenerator} from './inputs/RangeInput';
import {integerInputGenerator} from './inputs/IntegerInput';
import {realNumberInputGenerator} from './inputs/RealNumberInput';
import {decimalInputGenerator} from './inputs/DecimalInput';
import {dateInputGenerator} from './inputs/DateInput';
import {singleSelectInputGenerator} from './inputs/SingleSelectInput';
import {multiSelectInputGenerator} from './inputs/MultiSelectInput';
import {arrayInputGenerator} from './inputs/ArrayInput';
import {selectorInputGenerator} from './inputs/SelectorInput';
import {booleanInputGenerator} from './inputs/BooleanInput';
import {labelInputGenerator} from './inputs/LabelInput';
import {fileInputGenerator} from './inputs/FileInput';

export const generators = {
  [InputType.STRING]: stringInputGenerator,
  [InputType.INTEGER]: integerInputGenerator,
  [InputType.REAL_NUMBER]: realNumberInputGenerator,
  [InputType.DECIMAL]: decimalInputGenerator,
  [InputType.DATE]: dateInputGenerator,
  [InputType.SINGLE_SELECT]: singleSelectInputGenerator,
  [InputType.MULTI_SELECT]: multiSelectInputGenerator,
  [InputType.ARRAY]: arrayInputGenerator,
  [InputType.RANGE]: rangeInputGenerator,
  [InputType.BOOLEAN]: booleanInputGenerator,
  [InputType.LABEL]: labelInputGenerator,
  [InputType.SELECTOR]: selectorInputGenerator,
  [InputType.FILE]: fileInputGenerator,

  // [InputType.FILEUPLOAD]: rangeInputGenerator,
  // [InputType.REFERENCETYPE]: rangeInputGenerator,
  // [InputType.JSON]: rangeInputGenerator,
};
